import { z } from "zod";

/** Backlog から機械的に推定した関連プロジェクト・参加者の候補(サジェスト)。確定は人が行う。 */
export const backlogProjectSuggestionSchema = z.object({
  key: z.string(),
  name: z.string(),
  url: z.string(),
  reasons: z.array(z.string()),
  /** 0〜1。ルールベースでは理由の数から機械的に付ける。 */
  confidence: z.number(),
});
export type BacklogProjectSuggestion = z.infer<typeof backlogProjectSuggestionSchema>;

export const participantSuggestionSchema = z.object({
  /** Backlog 上の表示名。 */
  name: z.string(),
  backlogUserId: z.string(),
  /** 表示名で照合できた既知の参加者のメール。見つからなければ null(SPEC §2.5) */
  portalUserId: z.string().nullable(),
  portalDisplayName: z.string().nullable(),
  reasons: z.array(z.string()),
  confidence: z.number(),
});
export type ParticipantSuggestion = z.infer<typeof participantSuggestionSchema>;

export const projectSuggestionsResponseSchema = z.object({
  backlogProjects: z.array(backlogProjectSuggestionSchema),
  participants: z.array(participantSuggestionSchema),
  basis: z.object({
    leadIssueKey: z.string().nullable(),
    /** 参加者の抽出に使った起点(受注日)。 */
    since: z.string().nullable(),
    backlogProjectKeys: z.array(z.string()),
  }),
  fetchedAt: z.string(),
  /** LLM(エージェント)による推定か、ルールベース(候補生成 + 文字の近さで絞り込み)か。 */
  method: z.enum(["LLM", "RULES"]),
  model: z.string().nullable(),
  /** LLM からの補足(任意)。 */
  note: z.string().nullable(),
});
export type ProjectSuggestionsResponse = z.infer<typeof projectSuggestionsResponseSchema>;
